<app-shared-workshop-card
  [title]="workshop.title"
  [coverImage]="workshop.coverImage"
  [detailsLink]="workshop.courseLink"
  [description]="showDescription ? workshop.description : undefined"
  [isRegisteredAndPending]="isRegisteredAndPending"
  [isRegisteredAndApproved]="isRegisteredAndApproved"
  [isRegisteredAndRejected]="isRegisteredAndRejected"
  [rows]="cardRows"
  [actions]="cardActions"
></app-shared-workshop-card>

<dx-popup
  deferRendering="true"
  contentTemplate="content"
  height="auto"
  width="auto"
  hideOnOutsideClick="true"
  rtlEnabled="true"
  [(visible)]="showApprovalPromptPopup"
>
  <div *dxTemplate="let data of 'content'">
    <app-registration-approval-prompt></app-registration-approval-prompt>
  </div>
</dx-popup>
